<template>
  <div class="p-6 ml-64 min-h-screen flex flex-col overflow-hidden">
    <SpinnerComp v-if="loading" :fullscreen="true" />
    <div v-else>
      <!-- Título -->
      <div>
        <h1 class="text-[#1E5D22] font-semibold text-3xl mb-2 ml-8 mt-5">
          Nómina
        </h1>
        <p class="text-[#817F7F] text-xl ml-8">{{ nombres[0] }}</p>
      </div>

      <div class="ml-8 mt-9 flex justify-between items-center w-[1160px]">
        <div class="flex items-center gap-3">
          <!-- Selector de fechas -->
          <div
            class="flex gap-4 px-4 py-2 bg-white border border-[#969292]/30 rounded-xl"
          >
            <span class="text-[#817F7F] font-semibold mr-1 text-lg"
              >Tiempo:</span
            >
            <select
              v-model="opcionTiempo"
              class="text-black border-none focus:outline-none focus:ring-0 pr-4 -ml-4 text-lg"
            >
              <option value="hoy">Hoy</option>
              <option value="semana">Esta semana</option>
              <option value="mes">Este mes</option>
              <option value="todo">Todo el tiempo</option>
              <option value="fecha">Seleccionar fecha</option>
              <option value="rango">Rango de fechas</option>
            </select>
          </div>

          <!-- Input para Seleccionar fecha -->
          <input
            v-if="opcionTiempo === 'fecha'"
            type="date"
            v-model="fecha"
            class="px-4 py-2 border border-[#969292]/30 rounded-xl text-black text-lg"
          />

          <!-- Inputs para Rango de fechas -->
          <div v-if="opcionTiempo === 'rango'" class="flex gap-2">
            <input
              type="date"
              v-model="fechaInicio"
              class="px-4 py-2 border border-[#969292]/30 rounded-xl text-black text-lg"
            />
            <input
              type="date"
              v-model="fechaFin"
              class="px-4 py-2 border border-[#969292]/30 rounded-xl text-black text-lg"
            />
          </div>
        </div>

        <!-- Botón Generar PDF -->
        <button
          @click="generarPDF"
          class="px-6 py-2 font-semibold text-white bg-[#00932A] rounded-xl"
        >
          Generar PDF
        </button>
      </div>

      <div
        class="bg-white rounded-2xl border border-[#969292]/30 p-6 w-[1160px] ml-8 mt-12"
      >
        <h1 class="text-[#1E5D22] font-semibold text-2xl mb-3 ml-2">Ventas</h1>
          <div v-if="filtroActivo !== 'todo'" class="flex justify-end items-center mb-4 mr-2">
            <span class="text-gray-700 font-semibold mr-2 text-xl">Total: $</span>
            <span class="text-[#00932A] font-bold text-xl">{{ formatCurrency(totalVentas) }}</span>
          </div>
        <!-- Botones de filtro con fecha/rango -->
        <div class="flex flex-col ml-2">
          <!-- Botones -->
          <div class="flex flex-wrap gap-3 mb-4">
            <button
              :class="botonClase('todo')"
              @click="seleccionFiltro('todo')"
            >
              Todo
            </button>

            <button :class="botonClase('hoy')" @click="seleccionFiltro('hoy')">
              Hoy
            </button>

            <button
              :class="botonClase('fecha')"
              @click="seleccionFiltro('fecha')"
            >
              Seleccionar fecha
            </button>

            <button
              :class="botonClase('rango')"
              @click="seleccionFiltro('rango')"
            >
              Rango de fechas
            </button>
          </div>

          <!-- Bloque de fecha o rango -->
          <div
            v-if="filtroActivo === 'fecha' || filtroActivo === 'rango'"
            class="flex flex-wrap items-center gap-3 mb-4"
          >
            <!-- Fecha individual -->
            <div v-if="filtroActivo === 'fecha'" class="flex flex-col">
              <label class="text-gray-700 font-medium">Fecha:</label>
              <input
                type="date"
                v-model="filtroFechaIndividual"
                class="mt-1 px-3 py-2 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
            </div>

            <!-- Rango de fechas -->
            <div v-if="filtroActivo === 'rango'" class="flex gap-2">
              <div class="flex flex-col">
                <label class="text-gray-700 font-medium">Fecha inicial:</label>
                <input
                  type="date"
                  v-model="filtroFechaInicio"
                  class="mt-1 px-3 py-2 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                />
              </div>
              <div class="flex flex-col">
                <label class="text-gray-700 font-medium">Fecha final:</label>
                <input
                  type="date"
                  v-model="filtroFechaFin"
                  class="mt-1 px-3 py-2 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                />
              </div>
            </div>

            <!-- Botón Aplicar -->
            <button
              @click="cargarVentas"
              class="mt-6 py-2 px-3 bg-green-500 text-white rounded-lg"
            >
              Aplicar
            </button>
          </div>
        </div>

        <!-- Tabla  -->
        <DataTable
          class="border-none w-[1140px] -ml-[16px]"
          :headers="tableHeaders"
          :rows="tableRows"
          :visibleColumnsMobile="visibleColumnsForMobile"
          :columnWidths="columnWidths"
          :defaultRoute="'/operadores-venta'"
          :openModal="false"
          :columnIcons="{
            pagado: (value) =>
              value
                ? `<svg class='w-6 h-6 text-green-500' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'>
           <circle cx='12' cy='12' r='10' />
           <path stroke-linecap='round' stroke-linejoin='round' d='M9 12l2 2 4-4' />
         </svg>`
                : `<svg class='w-6 h-6 text-red-500' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'>
           <circle cx='12' cy='12' r='10' />
           <path stroke-linecap='round' stroke-linejoin='round' d='M15 9l-6 6M9 9l6 6' />
         </svg>`,
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";

export default {
  components: {
    DataTable,
    SpinnerComp,
  },
  data() {
    return {
      loading: true,
      nombres: ["Ezequiel Montes Rivas"],
      opcionTiempo: "hoy",
      fecha: null,
      fechaInicio: null,
      fechaFin: null,
      tableHeaders: ["ID", "Fecha", "Hora", "Operador", "Total", "Pagado"],
      tableRows: [],
      visibleColumnsForMobile: [0, 1, 2],
      columnWidths: ["10%", "20%", "20%", "30%", "10%"],
      totalVentas: 0,

      filtroActivo: "todo", // tipo de filtro activo
      filtroFechaIndividual: "", // fecha única
      filtroFechaInicio: "", // fecha inicio rango
      filtroFechaFin: "", // fecha fin rango
    };
  },
  mounted() {
    this.cargarVentas();
  },

  methods: {
    generarPDF() {
      const id = Number(this.$route.params.id);
      let filtroPayload = { id: id, filtro: this.opcionTiempo };

      if (this.opcionTiempo === "fecha") {
        if (!this.fecha) {
          const { notify } = require("@/utils/notify");
          notify("Por favor, selecciona una fecha.", { type: 'warn' });
          return;
        }
        filtroPayload.fecha = this.fecha;
      } else if (this.opcionTiempo === "rango") {
        if (!this.fechaInicio || !this.fechaFin) {
          const { notify } = require("@/utils/notify");
          notify("Por favor, selecciona ambas fechas para el rango.", { type: 'warn' });
          return;
        }
        filtroPayload.fecha_inicio = this.fechaInicio;
        filtroPayload.fecha_fin = this.fechaFin;
      }

      this.$axios
        .post("/generar-nomina", filtroPayload, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const newTab = window.open(url, "_blank");

          if (
            !newTab ||
            newTab.closed ||
            typeof newTab.closed === "undefined"
          ) {
            const link = document.createElement("a");
            link.href = url;
            link.download = `archivo-${id}.pdf`;
            link.click();

            const { notify } = require("@/utils/notify");
            notify(
              "El PDF no pudo abrirse en una nueva ventana. Se descargará automáticamente.",
              { type: 'info' },
            );
          }
        })
        .catch((error) => {
          console.error("Error al generar PDF:", error);
          const { notify } = require("@/utils/notify");
          notify(error?.response?.data?.message || "Error al generar el PDF.", { type: 'error' });
        });

      console.log("Datos para generar nómina:", filtroPayload);
    },
    seleccionFiltro(tipo) {
      this.filtroActivo = tipo;

      // Limpiar fecha única si no es el filtro de fecha individual
      if (tipo !== "fecha") this.filtroFechaIndividual = "";

      if (tipo !== "rango") {
        this.filtroFechaInicio = "";
        this.filtroFechaFin = "";
      }

      if (tipo === "todo" || tipo === "hoy") {
        this.cargarVentas();
      }
    },
    botonClase(tipo) {
      return [
        "px-4 py-2 rounded-lg border text-gray-700 transition",
        this.filtroActivo === tipo
          ? "border-green-500 bg-white" // botón activo
          : "border-gray-300 bg-white hover:border-green-400 hover:bg-gray-100", // botón inactivo
      ];
    },

    cargarVentas() {
      const id = this.$route.params.id;

      const params = { filtro: this.filtroActivo };

      // Agregamos fecha si el filtro es fecha
      if (this.filtroActivo === "fecha" && this.filtroFechaIndividual) {
        params.fecha = this.filtroFechaIndividual;
      }

      // Agregamos rango si el filtro es rango
      if (
        this.filtroActivo === "rango" &&
        this.filtroFechaInicio &&
        this.filtroFechaFin
      ) {
        params.fecha_inicio = this.filtroFechaInicio;
        params.fecha_fin = this.filtroFechaFin;
      }

      this.loading = true;

      this.$axios
        .get(`/getSalesOperator2/${id}`, { params })
        .then((response) => {
          this.nombres = response.data.nombres;
          this.tableRows = response.data.ventas.map((item) => ({
            ID: item.id,
            Fecha: item.fecha,
            Hora: item.hora,
            Operador: item.operador,
            Total: item.total,
            pagado: item.pagado,
          }));
          // Calcular suma total de las ventas filtradas
          this.totalVentas = response.data.ventas.reduce((acc, it) => {
            const val = parseFloat(it.total);
            return acc + (isNaN(val) ? 0 : val);
          }, 0);
          this.loading = false;
        })
        .catch((error) => {
          const { notify } = require("@/utils/notify");
          notify(error.response?.data?.message || "Error al cargar ventas", { type: 'error' });
          this.loading = false;
        });
    },
    formatCurrency(value) {
      try {
        return new Intl.NumberFormat("es-ES", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(value) || 0);
      } catch (e) {
        return value;
      }
    },
  },
};
</script>
